import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { truncateTotalLength } from 'helpers/assets';
import { formatAmount } from '@nbx/frontend-helpers/format';
import TradeItem from '../TradeItem';
import styles from './styles.module.scss';
import sharedStyles from '../styles.module.scss';

function Spread({ spread, market }) {
  const { t } = useTranslation();
  return (
    <tbody className={classnames([sharedStyles.tableBody, styles.spreadTableBody])}>
      <tr className={classnames([sharedStyles.tableRow, styles.orderRow])}>
        <td className={styles.amountGraphCell} />
        <td className={sharedStyles.tableCell}>
          <TradeItem muted styles={[styles.priceSpread]} title={spread} rightAligned>
            {truncateTotalLength(formatAmount(spread, market.minTickLength), 12)}
          </TradeItem>
        </td>
        <td className={classnames([sharedStyles.tableCell, styles.spreadLabel])}>
          <TradeItem styles={[styles.spreadLabel]} leftAligned>
            {t('common_spread')}
          </TradeItem>
        </td>
        <td className={sharedStyles.tableCell} />
      </tr>
    </tbody>
  );
}

Spread.propTypes = {
  spread: PropTypes.number.isRequired,
  market: PropTypes.object.isRequired
};

export default Spread;
